export const adminUsers = [
    '01612341234',
    '01012345678',
    '01012341234',
    '01098005226',
    '01049229038',
    '01039023996',
    '01037534075',
];
